import * as types from '@/store/mutationTypes'
import * as langMd from '@/js/lang/lang'
import * as tokenPrc from '@/js/tokenProcess'

const defaultLang = localStorage.getItem('scLang') || langMd.nvgLang
const state = {
  lang: defaultLang,
  theme: {
    color: 'Light'
  },
  user: {
    id: 0,
    name: '',
    role: '',
    loginTs: 0
  },
  curMessage: {
    message: '',
    type: 'success'
  },
  preRouteName: '',
  selDevGrpName: '',
  systemInfo: {
    location: 'cloud'
  }
}

const getters = {
  curLang: state => {
    return state.lang
  },
  curRole: state => {
    return state.user.role
  },
  curTheme: state => {
    return state.theme.color
  }
}

const mutations = {
  [types.SET_LANG] (state, lang) {
    state.lang = lang
  },
  [types.SET_CUR_MSG] (state, msg) {
    state.curMessage = msg
  },
  [types.SET_CUR_LOGIN_USER] (state, user) {
    state.user = user
  },
  [types.SET_PRE_ROUTE_NAME] (state, preRouteName) {
    state.preRouteName = preRouteName
  },
  [types.SET_SEL_DEV_GRP_NAME] (state, selDevGrpName) {
    state.selDevGrpName = selDevGrpName
  },
  [types.SET_THEME_COLOR] (state, color) {
    state.theme.color = color
  },
  [types.SET_SYSTEM_INFO] (state, systemInfo) {
    state.systemInfo = systemInfo
  }
}

const actions = {
  setLang ({commit, state}, lang) {
    commit(types.SET_LANG, lang)
    langMd.setLang(lang)
  },
  getLoginUserInfo ({commit, state}) {
    let user = tokenPrc.getUserInfoFromToken()
    if (user != null) commit(types.SET_CUR_LOGIN_USER, user)
    // !!!moidfy userinfo here
    // let user = {}
    // user.id = 1
    // user.name = 'user1'
    // user.role = 'Admin'
    // user.loginTs = 0
    // if (user != null) commit(types.SET_CUR_LOGIN_USER, user)
  },
  setSystemInfo ({commit, state}, systemInfo) {
    commit(types.SET_SYSTEM_INFO, systemInfo)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/global.js